/**
 * Helper to dynamically load the Razorpay checkout script if not present
 */
export const loadRazorpayScript = () => {
    return new Promise((resolve) => {
        if (typeof window !== 'undefined' && window.Razorpay) {
            resolve(true);
            return;
        }
        const existingScript = document.querySelector('script[src*="checkout.razorpay.com"]');
        if (existingScript) {
            if (window.Razorpay) {
                resolve(true);
                return;
            }
            existingScript.addEventListener('load', () => resolve(true));
            existingScript.addEventListener('error', () => resolve(false));
            return;
        }
        const script = document.createElement('script');
        script.src = 'https://checkout.razorpay.com/v1/checkout.js';
        script.async = true;
        script.onload = () => resolve(true);
        script.onerror = () => resolve(false);
        document.body.appendChild(script);
    });
};

/**
 * Open Razorpay Standard Checkout Modal
 */
export const openRazorpayModal = async ({
    orderId,
    amount,
    currency = 'INR',
    name = 'ZoyoTrip',
    description = 'Hotel Room Booking',
    prefill = {},
    notes = {},
    keyId = null,
    onSuccess,
    onDismiss,
    onFailure
}) => {
    const isLoaded = await loadRazorpayScript();
    if (!isLoaded || !window.Razorpay) {
        throw new Error('Razorpay SDK failed to load. Please check your internet connection or ad-blocker.');
    }

    const razorpayKey = keyId || process.env.REACT_APP_RAZORPAY_KEY_ID || 'rzp_test_TsTwglFlpMCFIA';

    // Sanitize prefill parameters
    const prefillObj = {};
    if (prefill.name && String(prefill.name).trim()) {
        prefillObj.name = String(prefill.name).trim();
    }
    if (prefill.email && String(prefill.email).trim() && String(prefill.email).includes('@')) {
        prefillObj.email = String(prefill.email).trim();
    }
    const rawContact = prefill.phone || prefill.contact || '';
    const cleanContact = String(rawContact).replace(/\D/g, '').slice(-10);
    if (cleanContact.length === 10) {
        prefillObj.contact = cleanContact;
    }

    const options = {
        key: razorpayKey,
        amount: amount, // in paise
        currency: currency,
        name: name,
        description: description,
        order_id: orderId,
        prefill: prefillObj,
        notes: notes,
        theme: {
            color: '#2563eb' // ZoyoTrip brand blue
        },
        modal: {
            ondismiss: () => {
                if (typeof onDismiss === 'function') {
                    onDismiss();
                }
            }
        },
        handler: (response) => {
            // response contains: razorpay_payment_id, razorpay_order_id, razorpay_signature
            if (typeof onSuccess === 'function') {
                onSuccess(response);
            }
        }
    };

    try {
        const rzp = new window.Razorpay(options);

        rzp.on('payment.failed', (response) => {
            if (typeof onFailure === 'function') {
                onFailure(response.error || response);
            }
        });

        rzp.open();
        return rzp;
    } catch (err) {
        console.error('Razorpay initialization exception:', err);
        throw err;
    }
};
